import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=3c354f84&scoped=true&"
import script from "./image-preview.vue?vue&type=script&lang=js&"
export * from "./image-preview.vue?vue&type=script&lang=js&"
import style0 from "./image-preview.vue?vue&type=style&index=0&id=3c354f84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c354f84",
  null
  
)

export default component.exports